define('models/strategyRetiredAudienceSegment',["jQuery", "T1", "Backbone", "T1Model", "T1Collection", "collections/strategyRetiredAudienceSegments"], function ($, T1, Backbone, T1Model, T1Collection, strategyRetiredAudienceSegments) {
  T1.Models.StrategyRetiredAudienceSegment = T1Model.extend({
    url: "retired_audience_segments/",
    fixture: "-strategy_retired_audience_segments"
  });
  return T1.Models.StrategyRetiredAudienceSegment;
});
